module.exports = __webpack_public_path__ + "img/ring_skip_skip_null_null.0662b11a.png";